import { gql } from 'graphql-request';

export const GET_MY_OUTGOING_INVITATIONS_COUNT = gql`
  query CoreOrganizations {
    coreOrganizationInvitations {
      count(filter: { isIncoming: null })
    }
  }
`;
